import axios from '../axios'
import { checkResponse, getProjectId } from '../utils'
import { apiV1 } from '../utils/constant';

/**
 * @function getspec
 * @desc 获取表单
 * @returns {Object}
 */
const getspec = () => {
  return axios
    .get(`${apiV1}/projects/${getProjectId()}/ucases/spec?view=web-new`)
    .then(checkResponse)
}

/**
 * @function submitCase
 * @desc 提交表单
 * @returns {Object}
 */
const submitCase = (data) => {
  return axios
    .post(`${apiV1}/projects/${getProjectId()}/ucases`, { data })
    .then(checkResponse)
}

export {
  getspec,
  submitCase
}
